import React, { Component } from 'react';
import AiOption from "./AiOption";
import AiInputWrap from "./AiInputWrap";
import AiReviewWrap from './AiReviewWrap';
import {stoneName} from  '../reducers/utils'
import {ALL_STONES} from  '../constants'
//import {Toolbar} from 'primereact/components/toolbar/Toolbar';
import { Dialog } from 'primereact/components/dialog/Dialog';

import {Button} from 'primereact/components/button/Button';
import { SPECIAL_NOTE_ACTIVATE,SPECIAL_NOTE,VERSION } from '../constants';

let metal2name={
  "no":"no",
  "s":"silver",
  "g10y":"gold",
  "g10w":"silver",
  "g14w":"silver",
  "g14y":"gold",
  "spy":"gold",
  "spr":"rose",
  "g10r":"rose",
  "g14r":"rose",
  
}

class AiOptionSet extends Component {
  

  render() {
   // console.log('get all options',this.props.options);
    var rows = [];
    var last =0 
    var cur_option
    var active_view = this.props.active_view
    var optionE = this.props.optionE;
    var lscheck = this.props.lsbefore == undefined
    if (optionE) optionE = optionE.preview;
    if (!this.props.altered && !optionE && !lscheck) active_view = (1+parseInt(this.props.lsbefore))
    if (this.props.charms) active_view = 1
    if (this.props.options['options_all'] !== undefined) {
      last = this.props.options['options_all'].length -1
    }  
    var singleStoneCount = 0
    for (let i in this.props.options['options_all']) {
      cur_option= this.props.options['options_all'][i]
      if (ALL_STONES.indexOf(cur_option) !== -1 && this.props.options['options_' + cur_option].show === true)
        singleStoneCount +=1
    }
    for (let i in this.props.options['options_all']) {
      cur_option= this.props.options['options_all'][i]
      //console.log('last value',cur_option,parseInt(i,10),last, this.props.single_sc_option)
      var lastValue ='false'
      if (parseInt(i,10)===last || (cur_option === "sc" && this.props.single_sc_option )) {
        lastValue = 'true' 
        //console.log('let lastValue be TRUE')
      } 

      var cur_details= this.props.options['options_' + cur_option]
      //console.log('activetype=',this.props.activetype[parseInt(cur_details['option_value'])-1],this.props.activetype,cur_details)
      //console.log('cur_option',cur_option,this.props.options)
      var cur_name = cur_details.name
      if (cur_details.option_name === 'stone') {
        if (cur_option ==='a1' && this.props.s === '3947')
          cur_name = "Central Stones"
        else 
        {
          if (singleStoneCount ===1)
            cur_name = "Stone"
          else
            cur_name = stoneName[cur_option]
        } 

      }
      var cur_value = this.props.options['value_' + cur_option]
      var option_name =  this.props.options['options_' + cur_option].option_name !== undefined ? ' ai-name-'+this.props.options['options_' + cur_option].option_name: ''
   //   console.log('this.props.option_name',option_name,this.props.option_name,cur_details)
     ///? if ("active_view" in cur_details)
     ///?   active_view =cur_details.active_view
       // console.log('set v',active_view)  

      if (cur_details.show)
      {
      //var actionAttr= {attr:'add',value:cur_details['option_value']}
    //  var actionAttrActive= cur_details['option_value']
      //if (cur_details.type==='accordion')
      //  console.log('accordion',actionAttr,actionAttrActive)
      var postfix=undefined
      if (this.props.cs_details.hasOwnProperty(cur_option) )
        postfix=this.props.cs_details[cur_option]
       switch (cur_details.type) {
  
       case 'select':
        case 'control':
        //console.log('cur_option',cur_details,cur_option,this.props.cs_details,this.props.cs_detail1,this.props.np,this.props.maxclist,this.props.maxclist2)
     //  console.log('cur_opt2',this.props.realinit, cur_details      )
        
        if (cur_details.option_name!=='acat' || (cur_details.option_name==='acat' && this.props.maxclist))
        if (cur_details.option_name!=='chain' || (cur_details.option_name==='chain' && (this.props.realinit ==='init' ||this.props.realinit === undefined )))
        if (cur_details.option_name!=='acust' || (cur_details.option_name==='acust' && (this.props.realinit ==='init'||this.props.realinit === undefined ) ))
  
        rows.push(<AiOption 
            key={cur_option} 
            name={cur_name} 
            attr={cur_option} 
            children={cur_details.options} 
            optionNumber={this.props.optionNumber} 
            optionSize={this.props.optionSize}
            sizeName={this.props.sizeName}
            optionName={option_name}
            active_view={active_view}
            altered={this.props.altered}
            onClick={()=>{if(!this.props.altered)this.props.onClick}}
            initialValue={cur_value}  
            image_base={cur_details.image_base}
            image_postfix={cur_details.image_postfix}
            last= {lastValue}
            image_postfix1={postfix}
            acharm={this.props.acharm}
            options_all={this.props.options_all}
            />);
        /*    
  var l1='How to build your necklace'
  var l2= '1. Choose your charms'
  var l3= '2. Choose your metal for the necklace or remove the necklace to just buy charms'
  var l4= '3. Create your own unique charm necklace that tells your story'
if (this.props.showtext9082){
   l1='How to build your locket'
   l2= '1. Select your locket or remove the locket to just buy charms'
   l3= '2. Choose your charms'
   l4= '3. Create your own unique locket that tells your story'

}
*/
var helpwidth = (this.props.optionNumber * this.props.optionSize + 60).toString()
    

if (helpwidth >650)
  helpwidth=650
helpwidth = helpwidth.toString()

//var helpwidth= '650'
//if (window.innerWidth < 550)
//  helpwidth= '300'
//console.log('state',this.props.realinit,this.props.showtext9000)

    if (cur_details.option_name==='chain' && this.props.showtext9000 && (this.props.realinit !=='init' ))
//            rows.push(<div  key="text1" className='ai-text1'><b>{l1}</b><br/><br/>{l2}<br/>{l3}<br/>{l4}<br/>  </div>)
{
     rows.push(<div  key="text1" className="ai-splashinit" ><img alt='help' width={helpwidth} src='//static.thepersonalizedbest.com/pers4/9000-help.jpg'  onClick={(e)=>this.props.onInit(e.currentTarget.value)}  />  </div>)
  //   rows.push(<div key="start-init" className="ai-AddCharm2wrap ai-button-select" >
  //   <Button  key="add-charm" className="ai-AddCharm2 ai-button-select"   value="init" onClick={(e)=>this.props.onInit(e.currentTarget.value)} label="Start Customize"></Button></div>)
}
if (cur_details.option_name==='locket' && this.props.showtext9082)
//    rows.push(<div  key="text1" className='ai-text1'><b>{l1}</b><br/><br/>{l2}<br/>{l3}<br/>{l4}<br/></div>)
    rows.push(<div  key="text1" ><img alt='help'  width={helpwidth} src='//static.thepersonalizedbest.com/pers4/9082-help.jpg' />  </div>)


            //            console.log('cur_opt2',cur_details.option_name,this.props     )
   if ((cur_details.option_name==='metal' && this.props.chainm !=='-1' && this.props.charms  && this.props.s  === '9000' ))
   rows.push(<div  key="add-charm-metal-text" className='ai-metaltext'>{this.props.addbuttontext} <br/></div>)
   if ((cur_details.option_name==='metal' && this.props.chainm !=='-1' && this.props.charms  && this.props.s  === '9082' ))
   rows.push(<div  key="add-charm-metal-text" className='ai-metaltext'>{this.props.addbuttontextLocket} <br/></div>)
   if ((cur_details.option_name==='locket' && this.props.s  === '9082' && this.props.locket  === 'no'   ))
      rows.push(<div  key="add-charm-metal-text" className='ai-metaltext'>Selected: No Locket.  You can purchase the charms without the locket. <br/></div>)
  if ((cur_details.option_name==='chain' && this.props.s  === '9000' && this.props.chain  === 'no'   ))
      rows.push(<div  key="add-charm-metal-text" className='ai-metaltext'>No Chain.  You can purchase the charms without the chain. <br/></div>)

               if ((cur_details.option_name==='am' && this.props.np)||
               (cur_details.option_name==='locket' && this.props.locket ==='no') ||
               (cur_details.option_name==='chain' && this.props.chain ==='no') ||
               (cur_details.option_name==='metal' && this.props.chainm !=='-1' && this.props.charms)||
               (cur_details.option_name==='acharm' && this.props.acharm !== '-1' && this.props.s  === '9082' && this.props.acat ==='5' && this.props.np))
        //else if (cur_details.value==='add')
        {  //          rows.push(<Toolbar key={cur_option}><Button className="ai-charm100"   value={actionAttrActive} onClick={(e)=>this.props.onAdd(e.currentTarget.value)} label='Add Another Charm'></Button></Toolbar>)
                    rows.push(<div key="add-charmwrap" className="ai-AddCharm2wrap" >
                      <Button  key="add-charm" className="ai-AddCharm2 ai-button-select"   value={this.props.activetype} onClick={(e)=>this.props.onAdd(e.currentTarget.value)} label={this.props.addbutton}></Button></div>)
                 }
               //  console.log('maxclist',this.props.maxclist)
                 if (cur_details.option_name==='acat' && this.props.maxclist===false)
                 {

                             rows.push(<span><br/>You have reached the maximum number of Charms for the one order.</span>)
                             rows.push(<span><br/><br/>Press <b>Review/Remove</b> button to remove the charms from the order.</span>)
                  }
                break;
        case 'input':
        var key2= cur_option +'_' //+Math.random().toString()
        for (let i in cur_details.options) {
          key2+=cur_details.options[i].show.toString()[0]
        }

      //  console.log('InputWrap',cur_option,cur_details)
       var attr='e'
       if (cur_details['attr'] !== undefined )     
        attr=cur_details.attr
       rows.push(<AiInputWrap 
            key={key2} 
            name={cur_details.name} 
            attr={attr} 
            children={cur_details.options} 
            options_all={this.props.options_all}
            active_view={active_view}
            
        //    optionNumber={this.props.optionNumber} 
        //    optionSize={this.props.optionSize}
            />);
            break;
        default:
            break;
        
      }
    }
    }
    //console.log('rows',rows)
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize + 60) +'px';
    var note2a = <div><font color='red'></font></div>
    var aireview=''
    var note2 = <div>Order processing requires <font color='red'>8 Days PLUS shipping</font> time based on the shipping method you choose. Signature required for items over $1,000.</div>
    note2 = <div>Signature required for items over $1,000.</div>
    
  const metal2image={
      's':'W',
      'g10w':'W',
      'g10r':'R',
      'g10y':'Y',
      'spr':'R',
      'spy':'Y',
    }    
  
    let bcolor ='ai-bcolor-' + window.currentSite
    if (this.props.aireview)
      aireview=<AiReviewWrap/>
    else{
      let charmreview =''
        let charmlist=[]
        let charmstring= this.props.clist.split('_')
        let onecharm
        let oneimage
        //let charmmetal
        let keyi='start'
       var titlei =''
        var pricei=''
        //console.log('charmlist11',this.props)   
        if ((this.props.chainm !=='no' &&  this.props.s ==='9000') || (this.props.locket !=='no' &&  this.props.s !=='9000'))
        {
      //  console.log('charmlist',this.props.chainm,metal2name[this.props.chainm],this.props)   
           
        //charmmetal=metal2name[this.props.chainmetal]

        oneimage='https://us.thepersonalizedbest.com/engrave.jpg/?sku='+ this.props.s +'&material='+ metal2name[this.props.chainm] +'&chain='+ this.props.chainsku
        var skuprice = this.props.chainsku
        var delvalue='chain'
        if (this.props.s !=='9000'){
          skuprice=this.props.locket
          delvalue='locket'
        }
   //     console.log('pricedet0',this.props.pricedetails,skuprice+'-'+this.props.chainm)  
        
        if (this.props.pricedetails !== undefined && this.props.pricedetails.hasOwnProperty(skuprice+'-'+this.props.chainm)){
          //console.log('pricedet',this.props.pricedetails,onecharm)  
          titlei=this.props.pricedetails[skuprice+'-'+this.props.chainm][1]
          pricei=this.props.pricedetails[skuprice+'-'+this.props.chainm][0]
              
        charmlist.push(<div className='ai-charm-row'  key={'r-'+keyi}>
        <div className='ai-charm-col1' key={'c1-'+keyi}>
        <img   key={'i-chain'} alt="charm" width='50' height='50' src={oneimage}/>
        </div>
        <div className='ai-charm-col2'  key={'c2-'+keyi}>{titlei}</div>
        <div className='ai-charm-col3' key={'c3-'+keyi}>{pricei}</div>
        <div className='ai-charm-col4' key={'c4-'+keyi}>
        <img role='button'  key='b-chain'  alt='chain' width='20' height='20'    value={delvalue} onClick={(e)=>this.props.onDel(e.currentTarget.getAttribute('value'))}
        src='https://static.thepersonalizedbest.com/pers4/x.jpg'></img>

        </div>
         </div>)
         if (this.props.clistqty>0)
           charmlist.push(<hr key={'first-k'}/>)    

        }
    //    if (this.props.clistqty>0) 
        
        }
        if (this.props.clistqty>0) {
        for (let i in charmstring){
            titlei =''
            pricei=''
            onecharm=charmstring[i].split('|')
            oneimage='https://images.thepersonalizedbest.com/engrave.jpg/?mode=show&sku='+ this.props.s +'&material=no&text0='
          // console.log('onecharm)',i, onecharm  )
            if (onecharm[0]==='1'&& this.props.s==='9000')
                oneimage += (parseInt(onecharm[1],10) + onecharm[3].toUpperCase().charCodeAt(0) -65).toString()
            else
            oneimage+=onecharm[1]
                    
            if (onecharm[0]==='2')
                    oneimage += '|'+onecharm[3]
            else if (onecharm[1]==='6394' ||onecharm[1]==='6395' )
            {
              oneimage += '|'+onecharm[4]
              oneimage += '|'+onecharm[5]
                    oneimage += '|'+onecharm[3]
                    
            }
            else if (onecharm[1]==='6396' )
            {
              oneimage += '|'+onecharm[4]
              oneimage += '|'+onecharm[3]
                    
            }
            else if (onecharm[1]==='6997' )
            {
              oneimage += '|'+onecharm[4]
              oneimage += '|'+onecharm[3]
                    
            }
            oneimage+='|'+metal2image[onecharm[2]]
          //

            //charmmetal=metal2name[onecharm[2]]
            keyi ='delkey'+String(i)
            if (this.props.pricedetails !== undefined && this.props.pricedetails.hasOwnProperty(onecharm[1]+'-'+onecharm[2])){
        //    console.log('pricedet',this.props.pricedetails)  
            titlei=this.props.pricedetails[onecharm[1]+'-'+onecharm[2]][1]
            pricei=this.props.pricedetails[onecharm[1]+'-'+onecharm[2]][0]
            }
            
            charmlist.push(<div className='ai-charm-row'  key={'r-'+keyi}>
                <div className='ai-charm-col1' key={'c1-'+keyi}>
                <img   key={'i-'+keyi} alt="charm" width='50' height='50' src={oneimage}/>
                </div>
                <div className='ai-charm-col2'  key={'c2-'+keyi}>{titlei}</div>
                <div className='ai-charm-col3' key={'c3-'+keyi}>{pricei}</div>
                <div className='ai-charm-col4' key={'c4-'+keyi}>
                <img role='button'  key={'b-'+keyi}  alt='charm' width='20' height='20'   value={i} onClick={(e)=>this.props.onDel(e.currentTarget.getAttribute('value'))} 
                src='https://static.thepersonalizedbest.com/pers4/x.jpg'></img>

                </div>
                 </div>)
                 if (i <this.props.clistqty-1)
                        charmlist.push(<hr key={'hr-'+keyi}/>)    

        }
      }        //<Button className={bcolor}  label='Close' onClick={this.props.onHideCharm}/>
   //     console.log('charmlist',charmlist.length,charmlist)
        if (charmlist.length >0)
            charmreview=<div className='ai-table-wrap'>
            
            <div className='ai-table'>
                {charmlist}
                         
                             </div>       
                             </div>
            
            
        const footer = (
          <div>
            <Button
              key='closedialog' 
              label='Close'
              onClick={this.props.onHideCharm}
              className={bcolor}
            />
            
          </div>)
    let noteGem =''
      
    //      if (this.props.gems)
    noteGem = <div>Most natural gemstones pictured have been subject to an enhancement process or treatment (e.g. heating, oiling, diffusion, waxing, etc.), which may not be permanent and may require special care. Please refer to the FAQ section below for more information about gemstone enhancements and special care recommendations.</div>
    //console.log('width',window.innerWidth)   
    var dialogwidth= '550px'
    if (window.innerWidth < 550)
      dialogwidth= '300px'
    aireview =<div><Dialog key='dialog' modal={true} header="Selected Charms Review" maximized={true} visible={this.props.charmreview} footer={footer} 
    width={dialogwidth}
    
        resizable={true} draggable={false}  blockScroll={true} 
        className={'ai-best-dialog' } 
//        className={'ai-best-dialog ' + bcolor + (bsoverride == true ? ' override' : '')} 
      //  style={newstyle} 
        onHide={this.props.onHideCharm}>
          {charmreview}
          <div className='ai-review-note'>
                        {noteGem}
          </div>    
           <div className='ai-review-note'>
          {note2}
          </div> 
          <br/>
          <div className='ai-version'>Version {VERSION}</div> 
        </Dialog>
          
          </div>
          
        //console.log('')     
        //console.log(this.props.clist)
        //console.log(this.props.clist.split('_'))
        //console.log(charmlist)  
    }    
   // {charmreview}
      
    //const note2a = <div><font color='red'>Due to COVID-19, shipping is taking longer than expected. We will do our best to make sure your package arrives in time for Mother’s Day. This delivery date overrides regular processing times noted below.</font></div>
    if (SPECIAL_NOTE_ACTIVATE)
        note2a = <div><font color='red'>{SPECIAL_NOTE}</font></div>
  //      let w = window.innerWidth
  //      let h = window.innerHeight
  var addesa=''
  var esaval=''
  var esadetail=[]
  var i
  var addesa2='' 
  var addesa4='' 
  //console.log('esa',this.props.esa,this.props.price)    
  if (this.props.esa !== undefined)
  {
  for (i in   this.props.esa) {
    if (parseFloat(this.props.price) >= this.props.esa[i][0] && parseFloat(this.props.price) <= this.props.esa[i][1]) {
    //console.log( 'i',this.props.esa[i])
    esaval=this.props.esa[i][2]
    }
  }
  for (i in this.props.esadetail)
  if (this.props.esadetail[i][0] === 'Ring Sizing')
  {
   esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>4</sup></b></td><td className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
   addesa4=<p id="ringDisc" styleName="ai-esa-padding">
		<sup>4</sup>Allow ring sizing up or down two sizes.
	</p>
  }
   else if (this.props.esadetail[i][0] === 'Free One-Time Engraving'){
   esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>2</sup></b></td><td className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
   addesa2=<sup>1,2</sup> 
   }
   else 
      esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}</b></td><td className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
  addesa=
  <div>
  <div className="ai-esa-icon">
            <input type="checkbox" id="addToCartPlanSub"  onClick={(e)=>this.props.onESA(e.currentTarget.checked)}/>
        
            <img className='ai-esa-img' alt='ESA' width='18px' height='18px' src="//static.thepersonalizedbest.com/pers4/esaIcon.svg"></img>
            <div className="ai-chat-text">
                           <p>Protect Your Jewelry For Life<sup>1</sup> for ${esaval}</p>
                           <p className='ai-esa-font'> Enjoy lifetime service with a one-time purchase</p>
            </div> 
    
  </div>
  <div className="ai-esa-block">
  <table className="ai-esa-table">
                 <thead  className={"ai-esa-thead-"+  window.currentSite}>
			<tr>
				<th className="ai-esa-th">Service Needed</th>
				<th className="ai-esa-th">Typical Cost<sup>5</sup></th>
				<th className="ai-esa-th">With This Plan</th>
			</tr>
		</thead><tbody>
    {esadetail}
    </tbody>
                 </table>
      
  </div>
  <div className="ai-esa-th">
<a href={window.baseSiteUrl+"/lifetime-protection-plan"}  target="_blank">Learn more</a>
</div>

<span className="ai-esa-discl">
<div className="ai-esa-padding">
	<sup>1</sup>
		Excludes repair and replacement of diamonds and gemstones. 
	
    {addesa2}
		Other limitations apply. By purchasing, I agree to&nbsp;
	<u>
		<a target="_blank" href={window.baseSiteUrl+"/lifetime-protection-plan-details"}>Plan Terms and Electronic Delivery.</a>
	</u>
  {addesa4}
	<p id="costDisc" styleName="ai-esa-padding">
		<sup>5</sup>Costs may vary depending on specific service, size and material type.
	</p>
</div></span>
  </div>
  }
  var addchat=''
    
  //      if (h>w)
            addchat= 
            <div className="ai-chat-block">
            <div className="ai-chat-icon">
                                   <img alt='chat' width='45px' height='45px' src="//static.thepersonalizedbest.com/pers4/chat.jpg"></img>
            </div>
            <div className="ai-chat-text">
                           <p>Have a question about {this.props.title}?</p>
                           <p><a href="javascript:document.getElementsByClassName('LPMcontainer')[0].click();" >Chat Now</a></p>
            </div>
            </div> 

    return (
      <div className='ai-option-wrap' style={{width:maxSliderSize}}>
        <div className='ai-br'/>
     
      {rows}
      <p></p>
      {addesa}
      {aireview}
      <p></p>
      {addchat}
      {/* <div className='ai-special-note'>{note2a}</div> */}
      <p/>
      </div>
     
    );
  }
}
export default AiOptionSet;


// WEBPACK FOOTER //
// ./src/layout/AiOptionSet.js